import React, { useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import styles from "./TemplatePickerModal.module.css";

export default function TemplatePickerModal({ templates, onSelect, onClose }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div>
            <h2>Choose a page template</h2>
            <p className={styles.subtitle}>
              Replaces the sections on the current page. You can edit everything after.
            </p>
          </div>
          <button className={styles.closeBtn} onClick={onClose}>
            <IoCloseOutline />
          </button>
        </div>

        <div className={styles.grid}>
          {templates.map((tpl) => (
            <button key={tpl.key} className={styles.card} onClick={() => onSelect(tpl)}>
              <span className={styles.cardTop}>
                <span className={styles.cardIcon}>{tpl.icon}</span>
                <span className={styles.cardTitle}>{tpl.label}</span>
              </span>
              <span className={styles.cardDescription}>{tpl.description}</span>
              <span className={styles.cardCount}>
                {tpl.starterCategories?.length ? `${tpl.starterCategories.length} sections` : "Empty"}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
